import { toast } from 'react-toastify'

import api from 'services/financial/company'
import { handleValidate } from 'components/form/form-submit'

import { FormList } from './types'

export const handleGet = async (id: string) => {
  let res = await api.get(id)

  return res?.data?.data
}

export const handleValidateForms = async (form: FormList, addressForm: FormList): Promise<boolean> => {
  let success = true

  if (!(await handleValidate(form.form, form.validationSchema))) success = false
  if (!(await handleValidate(addressForm.form, addressForm.validationSchema))) success = false

  if (!success) toast.warn('Corrija os campos para prosseguir')

  return success
}

export const handleSave = async (values: any) => {
  let res = await api.update(values)

  return res?.data?.success
}
